import { type DayPickerProps } from 'react-day-picker';
import { enGB, enUS, fr, de, es, pt, ptBR, pl } from 'react-day-picker/locale';

// Use DayPicker's locale type directly (instead of importing Calendar from Aura)
// to avoid cross-package type identity issues in mixed date-fns environments.
type DayPickerLocale = NonNullable<DayPickerProps['locale']>;

type DayPickerLocaleLike = DayPickerLocale & { code?: string };

const localeMap: Record<string, DayPickerLocaleLike> = {
  // Primary markets
  'en-GB': enGB,
  'en-US': enUS,
  'fr-FR': fr,
  'de-DE': de,
  'es-ES': es,
  'pt-PT': pt,
  'pt-BR': ptBR,
  // Secondary / variant markets
  'en-IE': enGB,
  'en-CA': enUS,
  'en-PL': pl,
  'en-FR': fr,
  'fr-GB': enGB,
  'de-AT': de,
  // Language-only fallbacks
  en: enGB,
  fr,
  de,
  es,
  pt,
  pl,
};

const fallback: DayPickerLocaleLike = enGB;

export const getDayPickerLocale = (marketLocale: string): DayPickerLocale => {
  const exact = localeMap[marketLocale];
  if (exact) return exact;
  const lang = marketLocale.split('-')[0];
  if (lang === undefined) return fallback;
  return localeMap[lang] ?? fallback;
};
